import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';
import type { ShipType } from 'common/interfaces/order.interface';
import { SHIPPING_METHODS } from '@/constants/Order';

interface IShippingMethods {
  shipMethods: ShipType[];
}

const initialState: IShippingMethods = {
  shipMethods: SHIPPING_METHODS,
};

export const shipMethodsSlice = createSlice({
  name: 'cart',
  initialState,
  reducers: {
    setShipMethods: (state, action: PayloadAction<ShipType[]>) => {
      state.shipMethods = action.payload;
    },
    updateShipMethodProperties: (
      state,
      action: PayloadAction<{ shipTypeKey: string; properties: Partial<ShipType> }>
    ) => {
      const { shipTypeKey, properties } = action.payload;
      state.shipMethods = state.shipMethods.map((shipMethod) => {
        /** Finding the shipMethod with the specified shipTypeKey  */
        if (shipMethod.shipTypeKey === shipTypeKey) {
          return { ...shipMethod, ...properties };
        }

        return shipMethod;
      });
    },
  },
});

export const { setShipMethods, updateShipMethodProperties } = shipMethodsSlice.actions;

export default shipMethodsSlice.reducer;
